import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../shared/models/jobTypeCourt.model';

import { BsModalService } from 'ngx-bootstrap/modal';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map} from 'rxjs';
import { JobTypeDocument } from '../../../shared/models/jobTypeDocument.model';
import { JobTypeAffidavit } from '../../../shared/models/jobTypeAffidavit.model';

import { JobServiceTimeframe } from '../../../shared/models/jobServiceTimeframe.model';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { VariableCodeBlock } from 'src/app/shared/models/variableCodeBlockModel.model';




import { query } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { TemplateRef, ViewChild,  ViewEncapsulation } from '@angular/core';

import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { FilterSettingsModel, IFilter, ToolbarItems, GridComponent, GroupSettingsModel, IFilterUI, RowDataBoundEventArgs, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager } from '@syncfusion/ej2-data';

// import { WoocommerceOrderService, WoocommerceProductsService } from 'ngx-wooapi';
import { concatMap, from } from 'rxjs';


import { MysqlService } from 'src/app/services/mysql.service';
//checkbox selection options
import { SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ppsDistrHubActionList } from './../../../shared/models/ppsDistroHubActionList.model';

import { FileUploadsModalComponent } from 'src/app/manager/file-uploads-modal/file-uploads-modal.component'; 
import html2canvas from 'html2canvas';
import { ppsDistrHubPromotion } from 'src/app/shared/models/ppsDistroHubPromotion.model';
// import { WordpressService } from 'src/app/services/wordpress.service';
import { InsertHtml, QuickToolbarSettingsModel, RichTextEditorComponent, ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';

import { Form, FormsModule, Validators } from '@angular/forms';

// import{CodeMirror} from '@ctrl/ngx-codemirror'

// Now Code View COmponent
import * as CodeMirror from 'codemirror';
import { DomSanitizer } from 'node_modules/@angular/platform-browser';

@Component({
  selector: 'app-variable-code-block-update-widget',
  templateUrl: './variable-code-block-update-widget.component.html',
  styleUrls: ['./variable-code-block-update-widget.component.scss']
})
export class VariableCodeBlockUpdateWidgetComponent implements OnInit {



  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_court: any;

  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  job_service_rule: any;
  job_service_timeframe_count_types: any;
  job_service_timeframe_time_types: any;
  job_service_timeframe_time_when: any;
  job_service_timeframe_date_types: any;
  job_service_timeframe: any;
  brand_id: any;
  @Input() variable_code_block_id?: number;
  variable_code_block: any;
  variable_code_job_types: any;
  variable_code_block_insert_types: any;
  system_log_type_data_sectors: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService,
    // private productService: WoocommerceProductsService,
    // private orderService: WoocommerceOrderService,
    public datepipe: DatePipe,
    private _mysqlService: MysqlService,
     private sanitizer: DomSanitizer 

  ) { 

    this.brand_id = this.gfunc.sessionBrandId;
    this.variable_code_block_id = +this.route.snapshot.paramMap.get('variable_code_block_id');
  }


  ngOnChanges() {

    this.model = new VariableCodeBlock();
    this.getVariableCodeBlock(this.variable_code_block_id);
     this.getJobTypes();


    this.change.emit(this.intialCount);
   // this.getTraceCandidate(this.count);
//   this.model = new JobServiceTimeframe();
//  this.model = this.getJobServiceTimeframe(this.count);
//   this.getJobTypes();

//       // get the rules sql
//       this.getJobServiceTimeframeCountTypes();
//       this.getJobServiceTimeframeTimeTypes();
//       this.getJobServiceTimeframeTimeWhen();
//       this.getJobServiceTimeframeDateTypes();


  }

  ngOnInit() {


    this.model = new VariableCodeBlock();
    this.getVariableCodeBlock(this.variable_code_block_id);
    this.getVariableCodeBlockInsertTypes();
    this.getVariableCodeBlockTypes();
     this.getJobTypes();
     this.getSystemLogTypeDataSectors();
   
         // get the rules sql
        //  this.getJobServiceTimeframeCountTypes();
        //  this.getJobServiceTimeframeTimeTypes();
        //  this.getJobServiceTimeframeTimeWhen();
        //  this.getJobServiceTimeframeDateTypes();
   
  }





  getJobServiceRule(job_service_rule_id) {
    this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
       data => { this.job_service_rule = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getVariableCodeBlock(variable_code_block_id) {
    this._demoService.getVariableCodeBlock(variable_code_block_id).subscribe(
       data => { this.variable_code_block = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getVariableCodeBlockTypes() {
    this._demoService.getVariableCodeBlockTypes().subscribe(
        data => { this.variable_code_job_types = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }


    getVariableCodeBlockInsertTypes() {
      this._demoService.getVariableCodeBlockInsertTypes().subscribe(
          data => { this.variable_code_block_insert_types = data; },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }
  

   
  getJobServiceTimeframe(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    // this.model.job_type_location_id = 1;
   // this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }


  getJobTypeCourt(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
       data => { this.job_type_court = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeDocument(job_type_document_type_id) {
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
       data => { this.job_type_document = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getJobTypeAffidavit(job_type_affidavit_type_id) {
    this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
       data => { this.job_type_affidavit = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   



   getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   updateJobServiceTimeframe(model) {
    this._demoService.updateJobServiceTimeframe(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Service Timeframe Updated');
       // Subject to reload the manager component parent.
       this.closeParentModel.emit();
       // CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving Service Timeframe!');
         return console.error(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }



    updateVariableCodeBlock(model) {
      this._demoService.updateVariableCodeBlock(model).subscribe(
         data => {
         // console.log(model);
           // this.trace_candidate_update = data;
         this.toastr.success('Code Block Updated');
         // Subject to reload the manager component parent.
         this.closeParentModel.emit();
         // CreateJobTypeComponent.returned.next(false);
           return true;
         },
         error => {
           console.error('Error saving Code Block!');
           return console.error(error);
         }
        // err => console.error(err),
        // () => console.log('done updates')
      );
      }


   updateJobTypeAffidavit(model) {
    this._demoService.updateJobTypeAffidavit(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Affidavit Type Updated');
       // Subject to reload the manager component parent.
       this.closeParentModel.emit();
       // CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving Affidavit!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }
    


    
    getJobTypeCourts(job_type_location_id) {
      this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
         data => { this.job_type_courts = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
     sendJobTypeCourtsID(job_type_location_id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.sent_job_type_location_id = job_type_location_id;
      this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
    
    }


    getJobTypeDocumentTypes(job_type_court_id) {
      this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
         data => { this.job_type_document_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
     sendJobTypeDocumentTypesID(job_type_court_id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.sent_job_type_court_id = job_type_court_id;
      this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  
    }





    getJobServiceTimeframeCountTypes() {
      this._demoService.getJobServiceTimeframeCountTypes().subscribe(
         data => { this.job_service_timeframe_count_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
  
     getJobServiceTimeframeTimeTypes() {
      this._demoService.getJobServiceTimeframeTimeTypes().subscribe(
         data => { this.job_service_timeframe_time_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
  
  
     getJobServiceTimeframeTimeWhen() {
      this._demoService.getJobServiceTimeframeTimeWhen().subscribe(
         data => { this.job_service_timeframe_time_when = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
  
     getJobServiceTimeframeDateTypes() {
      this._demoService.getJobServiceTimeframeDateTypes().subscribe(
         data => { this.job_service_timeframe_date_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }

     getSystemLogTypeDataSectors() {
      this._demoService.getSystemLogTypeDataSectors().subscribe(
         data => { this.system_log_type_data_sectors = data;
        
        },
         err => console.error(err),
         () => console.log('System Log Type')
       );
     }
    

}
